<div class="row row-header">
	<div class="col-3 d-block">
		<div class="breadcrumbs">
			<button data-testid="SUBSYS2_PATFORM_BACK_BTN" type="button"
				class="btn btn-secondary-outline d-flex align-items-center px-3 py-2" (click)="back()">
				<i class="material-icons">arrow_back</i>
				{{ isBackToList() ? labels().PATIENT_CREATION_COMPONENT_PREVIOUS_PAGE_LIST :
				labels().PATIENT_CREATION_COMPONENT_PREVIOUS_PAGE }}
			</button>
		</div>
		<h1 data-testid="SUBSYS2_PATFORM_TITLE_TXT">
			{{ isEdit() ? labels().PATIENT_CREATION_COMPONENT_TITLE_EDIT : labels().PATIENT_CREATION_COMPONENT_TITLE_CREATE }}
		</h1>
	</div>
	<div class="col-9">
		<div class="panel mb-0 p-0 bg-transparent">
			<div class="panel alert flex-grow-0 mb-0">
				<div class="state-icon"><i class="material-icons md-18">report_problem</i></div>
				<p data-testid="SUBSYS2_PATFORM_LIABILITY_TXT">{{ labels().PATIENT_CREATION_COMPONENT_LIABILITY_MESSAGE }}</p>
			</div>
		</div>
	</div>
</div>

<div class="row row-contents mt-5">
	<div class="col-12">
		<patient-form />
	</div>
</div>